import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import BudgetsSummary from './components/BudgetsSummary';
import BudgetsMonthlyChart from './components/BudgetsMonthlyChart';
import BudgetsByUser from './components/BudgetsByUser';
import Box from 'elements/Box';
import moment from 'moment';
import {
  TextField, MenuItem, FormControl, InputLabel, Select,
} from '@mui/material';

const BudgetsDashboard = (props: any) => {
  const { setLoading } = props;

  const [summary, setSummary] = useState<any>({});
  const [users, setUsers] = useState<any[]>([]);
  const [monthly, setMonthly] = useState<any[]>([]);
  const [advisors, setAdvisors] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<string>('');

  const [formValues, setFormValues] = useState<any>({
    date: {
      startDate: moment().startOf('year').format('YYYY-MM'),
      endDate: moment().format('YYYY-MM'),
    },
  });

  /*=====================================================
  GENERATE MONTH OPTIONS (last 24 months)
  =====================================================*/
  const getMonthOptions = () => {
    const options = [];
    for (let i = 0; i < 24; i++) {
      const m = moment().subtract(i, 'months');
      options.push({
        value: m.format('YYYY-MM'),
        label: m.format('MMMM YYYY'),
      });
    }
    return options;
  };

  const monthOptions = getMonthOptions();

  /*=====================================================
  FETCH DATA
  =====================================================*/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const query: any = { ...formValues };
        if (selectedUser) {
          query.user_id = selectedUser;
        }

        await ApiRequest({
          url: '/dashboard/getBudgetsDashboard',
          method: 'get',
          headers: {
            ltkn: localStorage.getItem('ltkn'),
          },
          query,
          setResponse: (response: any) => {
            if (response.status === 'success') {
              setSummary(response.summary || {});
              setUsers(response.users || []);
              setMonthly(response.monthly || []);
              setAdvisors(response.advisors || []);
            }
          },
        });
      } catch (error) {
        console.error('Error fetching budgets dashboard data:', error);
      }
    };

    fetchData();
  }, [formValues, selectedUser]);

  return (
    <div id="BudgetsDashboard" className="ModuleContainer">
      <div className="ModuleWrapper">

        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h1>Presupuestos</h1>
          </div>
          <div className="boxContainerActions" style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            {/* Month range filters */}
            <TextField
              select
              label="Desde"
              size="small"
              value={formValues.date.startDate}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  date: { ...formValues.date, startDate: e.target.value },
                })
              }
              style={{ minWidth: 170 }}
            >
              {monthOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Hasta"
              size="small"
              value={formValues.date.endDate}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  date: { ...formValues.date, endDate: e.target.value },
                })
              }
              style={{ minWidth: 170 }}
            >
              {monthOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>

            {/* Advisor filter */}
            <FormControl size="small" style={{ minWidth: 180 }}>
              <InputLabel>Asesor</InputLabel>
              <Select
                value={selectedUser}
                label="Asesor"
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                {advisors.map((adv: any) => (
                  <MenuItem key={adv.user_id} value={adv.user_id}>
                    {adv.user_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div id="DashboardIn">
          {/* Summary indicators */}
          <BudgetsSummary summary={summary} />

          {/* Monthly trend chart */}
          <div className="dashboard_row">
            <Box title="Tendencia Mensual">
              <BudgetsMonthlyChart monthly={monthly} />
            </Box>
          </div>

          {/* Users consolidated table + chart */}
          <div className="dashboard_row">
            <Box title="Presupuesto por Comercial">
              <BudgetsByUser users={users} />
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetsDashboard;
